//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: ${({ width = "unset" }) => width};
    @media (max-width: 800px) {
        width: 100%;
    }
    & label {
        font-weight: 620;
        font-size: 14px;
    }
    &.disabled label {
        color: var(--purple-4);
    }
`;
export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    border: 1px solid var(--light-gray-1);
    border-radius: 5px;
    padding: 16px 12px;
    &.error {
        border-color: var(--red-3);
    }
    &.disabled {
        border-color: var(--purple-4);
        color: var(--purple-4);
        textarea {
            color: var(--purple-4);
            pointer-events: none;
        }
    }
`;
export const StyledTextArea = styled.textarea`
    outline: none;
    border: 0;
    border-bottom: 1px solid var(--light-blue-1);
    height: ${({ height = "100px" }) => height};
    resize: none;
    font-size: 14px;
    &.no-border {
        border: 0;
    }
    &::placeholder {
        color: var(--light-gray-4);
    }
`;
export const CharCounter = styled.span`
    color: var(--light-gray-2);
    font-weight: 600;
    font-size: 12px;
    align-self: flex-end;
`;